import { PropertyPaymentStatusResponse } from '@/client';

/**
 * Determines if a house payment status indicates the house is accessible
 * Validates against common paid statuses like 'active' and 'exempted'
 */
export const isHousePaymentValid = (paymentStatus: PropertyPaymentStatusResponse): boolean => {
	return paymentStatus.status === 'active' || paymentStatus.status === 'exempted';
};
